<template>
  <v-dialog v-model="showDialog" persistent max-width="1000px">
    <v-card>
      <!-- <v-card-title  color="primary darken-4">
                                <span class="headline">AGREGAR SUCURSAL</span>
                            </v-card-title> -->
      <v-toolbar color="primary darken-4" dark>
        <img
          :src="$store.state.iconoForm"
          height="42"
          alt="Acciones producto"
        />
        <v-toolbar-title class="ml-0 pl-3">
          <span class="hidden-sm-and-down">{{ $store.state.tituloForm }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="showDialog = false">
          <v-icon danger>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="formColor" :v-model="true" lazy-validation>
            <v-flex xs12 sm12 md12>
              <v-text-field
                label="Nombre del color *"
                v-model="color.nombre"
                placeholder="AZUL, VERDE, NEGRO, GRIS"
                hint="AZUL, VERDE, NEGRO, GRIS"
                :rules="[() => !!color.nombre || 'El campo es requerido']"
                :counter="60"
                required
              ></v-text-field>
            </v-flex>
            <br />
            <v-flex xs12 sm12 md6 lg6>
              <sketch-picker v-model="colors" @input="getSelectedColors" />
            </v-flex>
            <br />
            <v-flex xs12 sm12 md6 lg6>
              <v-text-field
                label="Codigo HTML *"
                v-model="color.codigoHtml"
                placeholder="#FFFFFF"
                hint="#FFFFFF"
                :rules="[() => !!color.codigoHtml || 'El campo es requerido']"
                :counter="15"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md6 lg6>
              <v-text-field
                label="Codigo RGB *"
                v-model="color.codigoRgb"
                placeholder="255, 255, 255, 1"
                hint="255, 255, 25, 15"
                :rules="[() => !!color.codigoRgb || 'El campo es requerido']"
                :counter="17"
                required
              ></v-text-field>
            </v-flex>
          </v-form>
        </v-container>
        <br />
        <small>* Indica que el campo es requerido</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="showDialog = false">Cerrar</v-btn>
        <v-btn
          color="primary darken-4"
          :loading="$store.state.operationInProgress"
          @click="saveColor"
          >Guardar</v-btn
        >
      </v-card-actions>
      <v-alert
        :value="$store.state.operationSuccess"
        color="success"
        icon="check_circle"
        transition="scale-transition"
      >
        Color guardado con éxito
      </v-alert>
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-card>
  </v-dialog>
</template>

<script>
import colorService from "@/services/colorService";
import { Sketch } from "vue-color";

export default {
  components: {
    "sketch-picker": Sketch,
  },
  props: {
    color: {
      type: Object,
    },
  },
  data() {
    return {
      showDialog: false,
      colors: {
        hex: "#000000",
        rgba: { r: 0, g: 0, b: 0, a: 1 },
      },
    };
  },
  methods: {
    openDialog() {
      this.showDialog = true;
    },
    getSelectedColors(c) {
      this.color.codigoHtml = c.hex;
      this.color.codigoRgb =
        c.rgba.r + ", " + c.rgba.g + ", " + c.rgba.b + ", " + c.a;
      console.log(c);
    },
    saveColor() {
      let self = this;

      if (self.$refs.formColor.validate()) {
        self.operationStart();

        if (self.color.colorId === 0) {
          self.addColor();
        } else {
          self.updateColor();
        }
      }
    },
    addColor() {
      let self = this;

      colorService
        .add(self.color)
        .then((result) => {
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onColorAdded", result);

          setTimeout(() => {
            self.showDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    updateColor() {
      let self = this;

      colorService
        .update(self.color)
        .then((result) => {
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onColorUpdated", result);

          setTimeout(() => {
            self.showDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    resetForm() {
      let self = this;
      self.operationReset();
      self.$refs.formColor.resetValidation();
      self.color.colorId = 0;
      self.color.nombre = "";
      self.color.codigoRgb = "";
      self.color.codigoHtml = "";
    },
  },
};
</script>
